import { httpClient, HttpMethod } from './http-client';

export const getCountries = (): any => {
  return httpClient('/countries', HttpMethod.Get, null);
};

export const getStatesByCountryId = (countryId: number) => {
  return httpClient(`/states/country/${countryId}`, HttpMethod.Get, null);
};
